import Api from '@/services/Api'

export default {
  fileInfo (url) {
    return Api().getfileinfo(url)
  },
  register (credentials) {
    return Api().get('status', credentials)
  },
  directory (id) {
    return Api().post('directory', id)
  },
  addfile (data) {
    return Api().post('addfile', data)
  },
  addfolder (data) {
    return Api().post('create-folder', data)
  },
  auth (data) {
    return Api().post('/get-auth-login-link', data)
  },
  authuser(data) {
    return Api().post('/authuser', data)
  },
  apilogin(data) {
    return Api().post('/generate-token', data)
  },
  updatesharedfileviewstatus (data) {
    return Api().post('/update-shared-file-view-status', data)
  },
  skipsetsecurity (data) {
    return Api().post('/skip-security-question', data)
  },
  getsize (data) {
    return Api().post('get-size', data)
  },
  adddepartmentfolder (data) {
    return Api().post('create-department-folder', data)
  },
  settrialpassword (data) {
    return Api().post('set-trial-password', data)
  },
  addgroupfolder (data) {
    return Api().post('create-group-folder', data)
  },
  addgroupfolderapproval (data) {
    return Api().post('create-group-folder-approval', data)
  },
  create_doc (data) {
    return Api().post('create-doc', data)
  },
  create_excel (data) {
    return Api().post('create-excel', data)
  },
  create_ppt (data) {
    return Api().post('create-ppt', data)
  },
  upload (data) {
    return Api().post('upload', data)
  },
  delete_department (data) {
    return Api().post('delete-department', data)
  },
  edit_department (data) {
    return Api().post('edit-department', data)
  },
  createaccount (data) {
    return Api().post('create-account', data)
  },
  useappsumocode (data) {
    return Api().post('/appsumo/create-account', data)
  },
  login (data) {
    return Api().post('login', data)
  },
  ulogin (data) {
    return Api().post('ulogin', data)
  },
  logout (data) {
    return Api().post('logout', data)
  },
  check_email (data) {
    return Api().post('check-email', data)
  },
  check_answer (data) {
    return Api().post('check-answer', data)
  },
  check_token (data) {
    return Api().post('check-token', data)
  },
  check_link (data) {
    return Api().post('check-link', data)
  },
  verify_email_link (data) {
    return Api().post('verify-email-link', data)
  },
  check_password_link (data) {
    return Api().post('check-password-link', data)
  },
  changepassword (data) {
    return Api().post('change-password', data)
  },
  forgotpassword (data) {
    return Api().post('forgot-password', data)
  },
  check (data) {
    return Api().post('check', data)
  },
  sendemailotp (data) {
    return Api().post('send-email-otp', data)
  },
  sendquestion (data) {
    return Api().post('send-question', data)
  },
  get_userdirectory (data) {
    return Api().post('get-userdirectory', data)
  },
  sendotp (data) {
    return Api().post('send-otp', data)
  },
  verifyotp (data) {
    return Api().post('verify-otp', data)
  },
  verifypassword (data) {
    return Api().post('verify-password', data)
  },
  setpassword (data) {
    return Api().post('set-password', data)
  },
  go_dashbaord (data) {
    return Api().post('go-dashboard', data)
  },
  setsecurity (data) {
    return Api().post('set-security', data)
  },
  create_department (data) {
    return Api().post('create-department', data)
  },
  create_user (data) {
    return Api().post('create-user', data)
  },
  edit_user (data) {
    return Api().post('edit-user', data)
  },
  company_details (data) {
    return Api().post('add-company-details', data)
  },
  verifyanswer (data) {
    return Api().post('verify-answer', data)
  },
  get_question (data) {
    return Api().post('get-question', data)
  },
  free_plan (data) {
    return Api().post('free-plan', data)
  },
  trial (data) {
    return Api().post('trial-plan', data)
  },
  choose_plan (data) {
    return Api().post('choose-plan', data)
  },
  getCountry (url) {
    return Api().getCountry(url)
  }
}
